import Vue from 'vue'
const MoneySpinner = () => import('v-money-spinner')
Vue.use(MoneySpinner)
const NumberInputSpinner = () => import('vue-number-input-spinner')
Vue.use(NumberInputSpinner)
const VueCurrencyInput = () => import('vue-currency-input')
Vue.use(VueCurrencyInput)